import Seo from "@/components/Seo";

export default function About() {
  const HERO = "https://images.unsplash.com/photo-1612703508477-00e02a9b170c";
  return (
    <div>
      <Seo
        title="About Dark Growers Genetics — Breeding the Future of Cannabis"
        description="Since 2018, Dark Growers has sourced the world's best breeder cuts. A community of cannabis breeders offering lab-tested clones and seeds with free next-day shipping."
        canonical="https://darkgrowers.com/about"
      />
      <section className="relative h-[50vh] flex items-end overflow-hidden">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/70" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pb-14 w-full">
          <p className="label-caps text-emerald-400 mb-3">Est. 2018</p>
          <h1 className="font-display text-5xl md:text-7xl text-slate-50 max-w-3xl leading-none">
            Breeding the <span className="italic text-emerald-400">future</span> of cannabis.
          </h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-20 space-y-8 text-slate-300/90 leading-relaxed">
        <p className="text-lg">
          Dark Growers is your one-stop shop for all your clone and seed needs. Since 2018 we've been
          traveling the world sourcing the best breeder cuts we can get our hands on.
        </p>
        <p>
          We are a community of cannabis breeders. If you are looking for a home that you can grow
          with, test with, and select with — then you are in the right place. We are dedicated to
          helping the culture earn the respect it deserves while breeding the future of cannabis at
          the same time.
        </p>
        <p>
          All of our genetics have been tested for HLVD, TMV, CMV, TSWV and INSV. We sell quality
          products that are tested and certified by reputable breeders and cultivations, with a
          surplus of flavors, high potency, great bag appeal, and strong terps.
        </p>
        <div className="border-l-2 border-emerald-500 pl-6 py-2">
          <p className="font-display text-2xl text-slate-100 italic">
            "We treat others as we want to be treated. Respect is key."
          </p>
        </div>
      </section>

      <section className="border-t border-white/10 bg-[#050505]">
        <div className="max-w-7xl mx-auto px-6 py-16 grid sm:grid-cols-3 gap-8 text-center">
          {[
            ["40+", "Premium Strains"],
            ["100+", "Verified Breeder Cuts"],
            ["2018", "Serving the Culture"],
          ].map(([n, l]) => (
            <div key={l}>
              <p className="font-display text-6xl text-emerald-400">{n}</p>
              <p className="label-caps text-slate-500 mt-2">{l}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
